import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ChevronRight } from "lucide-react";

const AREAS = [
  {
    name: "Homestead",
    desc: "Avocado groves, lime orchards, nurseries — our home base. Same-week scheduling.",
    href: "/drone-crop-spraying-homestead-fl/",
  },
  {
    name: "Miami-Dade County",
    desc: "Row crops along Krome Avenue, tomato and sweet-corn fields, tropical fruit groves.",
    href: "/drone-crop-spraying-miami-dade/",
  },
  {
    name: "Florida City",
    desc: "Sugarcane edge, tomato rows, beans and okra — extended South Miami-Dade coverage.",
    href: "/florida-city-crop-spraying/",
  },
  {
    name: "Redland Agricultural Area",
    desc: "Dense canopy specialists — avocado, mango, lychee, longan, ornamental nurseries.",
    href: "/agricultural-drone-spraying-redland-fl/",
  },
  {
    name: "Broward County",
    desc: "Nursery operations, palm farms, equestrian agriculture. Scheduled service area.",
    href: "/broward-county-drone-farming/",
  },
  {
    name: "Palm Beach County",
    desc: "Project-based coverage for larger row-crop and grove operations in the western county.",
    href: "/farm-drone-spraying-cost-florida/",
  },
];

export default function ServiceAreas() {
  return (
    <section id="service-areas" data-testid="service-areas" className="py-20 md:py-28 bg-muted/40">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-accent mb-4">Service areas</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary font-bold leading-tight">
            Service Areas: Homestead, Miami, Florida City, Redland, Broward County
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted-foreground">
            AeroAcres serves every major South Florida agricultural pocket from our Homestead base — from the
            Redland's limestone-soil groves to row-crop operations across Miami-Dade, Broward and Palm Beach County.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {AREAS.map((a, i) => (
            <motion.div
              key={a.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
            >
              <Link
                to={a.href}
                className="group block h-full p-6 rounded-3xl bg-card border border-border shadow-card hover:shadow-card-hover hover:border-accent/40 transition-all"
              >
                <div className="flex items-center justify-between">
                  <div className="h-10 w-10 rounded-2xl bg-accent/10 text-accent flex items-center justify-center">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <ChevronRight className="h-5 w-5 text-muted-foreground group-hover:text-accent transition-colors" />
                </div>
                <h3 className="mt-4 font-display text-xl font-bold text-primary group-hover:text-accent transition-colors">
                  {a.name}
                </h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{a.desc}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
